import React, { useState, useEffect } from "react";

const VerificationIdModal = ({
  isOpen,
  onClose,
  onSubmit,
  instituteName,
  instituteType,
}) => {
  const [verificationId, setVerificationId] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setVerificationId("");
      setError("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const getLabel = () => {
    return instituteType === "Other"
      ? "Employee ID"
      : "Roll Number / Student ID";
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!verificationId.trim()) {
      setError(`${getLabel()} is required`);
      return;
    }

    onSubmit(verificationId.trim());
    setVerificationId("");
    setError("");
  };

  const handleClose = () => {
    setVerificationId("");
    setError("");
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div
          className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          onClick={handleClose}
        ></div>

        {/* Modal positioning */}
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">
          &#8203;
        </span>

        {/* Modal content */}
        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
          <div>
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
              <svg
                className="h-6 w-6 text-blue-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
                />
              </svg>
            </div>
            <div className="mt-3 text-center sm:mt-5">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Request Affiliation
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  Please enter your {getLabel()} for{" "}
                  <span className="font-semibold text-gray-700">
                    {instituteName}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="mt-5 sm:mt-6">
            <div>
              <label
                htmlFor="verification-id"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                {getLabel()}
              </label>
              <input
                type="text"
                id="verification-id"
                value={verificationId}
                onChange={(e) => {
                  setVerificationId(e.target.value);
                  setError("");
                }}
                className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
                  error ? "border-red-500" : "border-gray-300"
                }`}
                placeholder={`Enter your ${getLabel()}`}
                autoFocus
              />
              {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
            </div>

            <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
              <button
                type="submit"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm transition-colors"
              >
                Submit Request
              </button>
              <button
                type="button"
                onClick={handleClose}
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm transition-colors"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VerificationIdModal;
